import { CreateMalpracticeInsuranceFormValues } from './types';

export const emptyMalInsuranceForm: CreateMalpracticeInsuranceFormValues = {
  activeFlag: false,
  coverageLimits: '',
  effectiveDate: '',
  expiryDate: '',
  insuranceCompany: '',
  policyNumber: '',
  policyType: { label: '', value: '' },
  producer: '',
};

const POLICY_TYPES = ['Medical Malpractice', 'Professional Liability'];
export const POLICY_OPTIONS = POLICY_TYPES.map((type) => ({ label: type, value: type }));
